// removed by extract-text-webpack-plugin
module.exports = {"container":"_11N9sHBgl-B3y7eOUzZaV","modalBox":"_3iq-ONsbbmA4lpyTEwTd14"};


/*****************
 ** WEBPACK FOOTER
 ** ./client/Modal.css
 ** module id = 714
 ** module chunks = 0 1
 **/